/**
 * Aleatoriedade para os enfeites do disfarce (separadores, pontuacao, ruido
 * de preenchimento).
 *
 * Vem do `randombytes_buf` do libsodium, nao de `Math.random`. Nada aqui e
 * secreto, mas manter uma unica fonte evita que alguem, mais tarde, copie o
 * padrao `Math.random` para um lugar onde ele seria fatal — e o ESLint do
 * projeto bloqueia esse import de qualquer forma.
 */
import { sodium } from '@criptohomer/crypto-core'
import { readU32BE } from './binary.js'

export function randomBytes(length: number): Uint8Array {
  return sodium().randombytes_buf(length)
}

/** Inteiro uniforme em [0, max). */
export function randomInt(max: number): number {
  if (max <= 1) return 0
  // Rejeicao para nao enviesar o resto da divisao.
  const limit = Math.floor(0x100000000 / max) * max
  for (;;) {
    const value = readU32BE(randomBytes(4), 0)
    if (value < limit) return value % max
  }
}

export function randomPick<T>(options: readonly T[]): T {
  const chosen = options[randomInt(options.length)]
  if (chosen === undefined) throw new Error('lista de opcoes vazia')
  return chosen
}
